module.exports = __webpack_public_path__ + "img/ria-fr.56c66a57.png";